import { render, staticRenderFns } from "./OrderConfirmList.vue?vue&type=template&id=5b3493b8&"
import script from "./OrderConfirmList.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirmList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports